import { render, staticRenderFns } from "./PreviewCommunication.vue?vue&type=template&id=7b4dcf78&scoped=true&"
import script from "./PreviewCommunication.vue?vue&type=script&lang=js&"
export * from "./PreviewCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4dcf78",
  null
  
)

export default component.exports